const admy = {
  // ── SeoPage ──
  "admy.seo_keywords_ph": "Keyword1, Keyword2, Keyword3",

  // ── SocialPage placeholders ──
  "admy.eg_followers": "e.g. 12.4k",
  "admy.eg_posts": "e.g. 238",
  "admy.eg_likes": "e.g. 48.6k",
  "admy.eg_shortcode": "e.g. CxG7kPqLmN3",

  // ── TranslationsPage group names ──
  "admy.grp_nav": "Navigation",
  "admy.grp_hero": "Home Hero",
  "admy.grp_services": "Services",
  "admy.grp_about": "About Us",
  "admy.grp_pricing": "Pricing",
  "admy.grp_booking": "Booking",
  "admy.grp_footer": "Footer",
  "admy.grp_gallery": "Gallery",
  "admy.grp_team": "Team",
  "admy.grp_clinic": "Clinic",
  "admy.grp_process": "Process",
  "admy.grp_trust": "Trust",
  "admy.grp_dental": "Dental",
  "admy.grp_overview": "Overview",
  "admy.grp_implants": "Implants",
  "admy.grp_contact": "Contact",
  "admy.grp_seo": "SEO",
  "admy.grp_admin": "Admin",
  "admy.grp_privacy": "Privacy Policy",
  "admy.grp_imprint": "Imprint",
  "admy.grp_agb": "Terms",
  "admy.grp_language": "Languages",
  "admy.grp_service_detail": "Service Detail",
  "admy.grp_instagram": "Instagram",

  // ── PageEditorPage field labels (home) ──
  "admy.f_hero_line1": "Hero — Line 1",
  "admy.f_hero_line2": "Hero — Line 2",
  "admy.f_hero_subtitle": "Hero — Subtitle",
  "admy.f_hero_cta": "Hero — CTA Button",
  "admy.f_services_tag": "Services — Tag",
  "admy.f_services_heading": "Services — Heading",
  "admy.f_services_subtitle": "Services — Subtitle",
  "admy.f_hair_title": "Hair Transplant — Title",
  "admy.f_hair_desc": "Hair Transplant — Description",
  "admy.f_dental_title": "Dental Cosmetics — Title",
  "admy.f_dental_desc": "Dental Cosmetics — Description",
  "admy.f_botox_title": "Botox & Fillers — Title",
  "admy.f_botox_desc": "Botox & Fillers — Description",
  "admy.f_services_cta": "Services — CTA Text",
  "admy.f_about_tag": "About — Tag",
  "admy.f_about_line1": "About — Line 1",
  "admy.f_about_line2": "About — Line 2",
  "admy.f_about_desc": "About — Description",
  "admy.f_about_cta": "About — CTA",
  "admy.f_pricing_tag": "Pricing — Tag",
  "admy.f_pricing_line1": "Pricing — Line 1",
  "admy.f_pricing_line2": "Pricing — Line 2",
  "admy.f_pricing_subtitle": "Pricing — Subtitle",
  "admy.f_pricing_cta": "Pricing — CTA",
  "admy.f_testimonials_tag": "Reviews — Tag",
  "admy.f_testimonials_heading": "Reviews — Heading",
  "admy.f_testimonials_subtitle": "Reviews — Subtitle",
  "admy.f_testimonial1_text": "Review 1 — Text",
  "admy.f_testimonial1_name": "Review 1 — Name",
  "admy.f_testimonial1_role": "Review 1 — Role",
  "admy.f_testimonial2_text": "Review 2 — Text",
  "admy.f_testimonial2_name": "Review 2 — Name",
  "admy.f_testimonial2_role": "Review 2 — Role",
  "admy.f_testimonial3_text": "Review 3 — Text",
  "admy.f_testimonial3_name": "Review 3 — Name",
  "admy.f_testimonial3_role": "Review 3 — Role",
  "admy.f_testimonial4_text": "Review 4 — Text",
  "admy.f_testimonial4_name": "Review 4 — Name",
  "admy.f_testimonial4_role": "Review 4 — Role",
  "admy.f_testimonial5_text": "Review 5 — Text",
  "admy.f_testimonial5_name": "Review 5 — Name",
  "admy.f_testimonial5_role": "Review 5 — Role",
  "admy.f_booking_tag": "Booking — Tag",
  "admy.f_booking_line1": "Booking — Line 1",
  "admy.f_booking_line2": "Booking — Line 2",
  "admy.f_booking_desc": "Booking — Description",
  "admy.f_booking_cta": "Booking — CTA",
  "admy.f_process_tag": "Process — Tag",
  "admy.f_process_heading": "Process — Heading",
  "admy.f_process_subtitle": "Process — Subtitle",
  "admy.f_trust_tag": "Trust — Tag",
  "admy.f_trust_heading": "Trust — Heading",
  "admy.f_trust_subtitle": "Trust — Subtitle",
  "admy.f_instagram_heading": "Instagram — Heading",
  "admy.f_instagram_cta": "Instagram — CTA",
  "admy.f_footer_company": "Footer — Company Name",
  "admy.f_footer_address": "Footer — Address",
  "admy.f_footer_phone": "Footer — Phone",
  "admy.f_footer_email": "Footer — Email",
  "admy.f_img_hero_bg": "Image — Hero Background",
  "admy.f_img_hair": "Image — Hair Transplant",
  "admy.f_img_dental": "Image — Dental Cosmetics",
  "admy.f_img_botox": "Image — Botox & Fillers",
  "admy.f_img_about_team": "Image — About Us Team",
  "admy.f_img_cta_bg": "Image — CTA Background",
  "admy.f_img_process_bg": "Image — Process Background",
  "admy.f_img_trust_bg": "Image — Trust Background",
  "admy.f_img_instagram_1": "Image — Instagram 1",
  "admy.f_img_instagram_2": "Image — Instagram 2",
  "admy.f_img_instagram_3": "Image — Instagram 3",
  "admy.f_img_instagram_4": "Image — Instagram 4",

  // ── shared / about ──
  "admy.f_tag": "Tag",
  "admy.f_headline_line1": "Headline Line 1",
  "admy.f_headline_line2": "Headline Line 2",
  "admy.f_description": "Description",
  "admy.f_quote": "Quote",
  "admy.f_name": "Name",
  "admy.f_position": "Position",
  "admy.f_mission_title": "Mission — Title",
  "admy.f_mission_text": "Mission — Text",
  "admy.f_values_title": "Values — Title",
  "admy.f_values_text": "Values — Text",
  "admy.f_why_albania_title": "Why Albania — Title",
  "admy.f_why_albania_text": "Why Albania — Text",
  "admy.f_cta_heading": "CTA — Heading",
  "admy.f_cta_subtitle": "CTA — Subtitle",
  "admy.f_cta_button": "CTA — Button",
  "admy.f_img_hero_bg_tirana": "Image — Hero Background (Tirana)",
  "admy.f_img_doctor": "Image — Team/Doctor Photo",
  "admy.f_img_mission": "Image — Mission",
  "admy.f_img_clinic": "Image — Clinic",

  // ── services ──
  "admy.f_headline": "Headline",
  "admy.f_subtitle": "Subtitle",
  "admy.f_hair_text": "Hair Transplant — Text",
  "admy.f_hair_price": "Hair Transplant — Price",
  "admy.f_dental2_title": "Dental — Title",
  "admy.f_dental2_text": "Dental — Text",
  "admy.f_dental2_price": "Dental — Price",
  "admy.f_botox2_title": "Botox — Title",
  "admy.f_botox2_text": "Botox — Text",
  "admy.f_botox2_price": "Botox — Price",
  "admy.f_surgery_title": "Surgery — Title",
  "admy.f_surgery_text": "Surgery — Text",
  "admy.f_surgery_price": "Surgery — Price",
  "admy.f_cta_text": "CTA Text",
  "admy.f_cta_subtitle2": "CTA Subtitle",
  "admy.f_img_dental2": "Image — Dental",
  "admy.f_img_botox2": "Image — Botox",
  "admy.f_img_surgery": "Image — Surgery",

  // ── pricing ──
  "admy.f_essential_title": "Essential — Title",
  "admy.f_essential_price": "Essential — Price",
  "admy.f_essential_desc": "Essential — Description",
  "admy.f_essential_features": "Essential — Features (comma-separated)",
  "admy.f_premium_title": "Premium — Title",
  "admy.f_premium_price": "Premium — Price",
  "admy.f_premium_desc": "Premium — Description",
  "admy.f_premium_features": "Premium — Features (comma-separated)",
  "admy.f_luxe_title": "Luxe — Title",
  "admy.f_luxe_price": "Luxe — Price",
  "admy.f_luxe_desc": "Luxe — Description",
  "admy.f_luxe_features": "Luxe — Features (comma-separated)",
  "admy.f_exclusif_title": "Exclusif — Title",
  "admy.f_exclusif_price": "Exclusif — Price",
  "admy.f_exclusif_desc": "Exclusif — Description",
  "admy.f_exclusif_features": "Exclusif — Features (comma-separated)",
  "admy.f_guarantee_text": "Guarantee Text",
  "admy.f_img_essential": "Image — Essential Package",
  "admy.f_img_premium": "Image — Premium Package",
  "admy.f_img_luxe": "Image — Luxe Package",
  "admy.f_img_exclusif": "Image — Exclusif Package",

  // ── booking ──
  "admy.f_hero_subtitle2": "Hero Subtitle",
  "admy.f_form_title": "Form — Title",
  "admy.f_form_subtitle": "Form — Subtitle",
  "admy.f_form_firstname": "Form — First Name Label",
  "admy.f_form_lastname": "Form — Last Name Label",
  "admy.f_form_email": "Form — Email Label",
  "admy.f_form_phone": "Form — Phone Label",
  "admy.f_form_service": "Form — Treatment Label",
  "admy.f_form_message": "Form — Message Label",
  "admy.f_form_privacy": "Form — Privacy Text",
  "admy.f_success_title": "Success — Title",
  "admy.f_success_message": "Success — Message",
  "admy.f_contact_tag": "Contact — Tag",
  "admy.f_contact_heading": "Contact — Heading",
  "admy.f_contact_subtitle": "Contact — Subtitle",

  // ── team ──
  "admy.f_cta_headline": "CTA Headline",
  "admy.f_cta_subtitle3": "CTA Subtitle",
  "admy.f_cta_button2": "CTA Button",
  "admy.f_show_more": "Show More",
  "admy.f_show_less": "Show Less",

  // ── gallery ──
  "admy.f_filter_all": "Filter — All",
  "admy.f_filter_dental": "Filter — Dental",
  "admy.f_filter_surgery": "Filter — Surgery",
  "admy.f_filter_hair": "Filter — Hair",
  "admy.f_filter_aesthetic": "Filter — Aesthetics",
  "admy.f_before_label": "Before Label",
  "admy.f_after_label": "After Label",
};

export default admy;
